import React, { Component } from 'react'
import Autocomplete from "@mui/material/Autocomplete";
import ClearIcon from "@mui/icons-material/Clear";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import store from '../../../redux/store';
import Utils from '../../../provider/Utils';
import FetchServerData from '../../../provider/FetchServerData';
import Button from "@material-ui/core/Button";
import CancelIconButton from '../buttons/CancelIconButton';
import { ValidatorForm } from 'react-material-ui-form-validator';
import PtsAlert from '../ptsAlert/PtsAlert';
import heic2any from "heic2any";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

class MessageVcard extends Component {
    tollfreeNumber = store.getState().appUserData.tollfreeNumber;
    defaultCountry = store.getState().staticData.defaultCountry;
    countryListArray = store.getState().staticData.countryList;
    header = store.getState().header.header;
    companyStateListArray = [];
    stateListArray = [];

    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            companyName: "",
            email: "",
            companyEmail: "",
            orgPhoneNumber: "",
            phoneNumber: "",
            website: "",
            line: "",
            companyLine: "",
            country: null,
            companyCountry: null,
            state: null,
            companyState: null,
            city: "",
            companyCity: "",
            zipCode: "",
            companyZipCode: "",
            photoInfo: null,
            photoUrl: null,
            open: false,
            isDragging: false,
            isCompanyAddress: false,
            isPersonalAddress: false,
            isPersonalDetails: false,
            onChange: props.onChange,
        };
    }

    showVCardForm(rowData) {
        if (rowData !== null) {

            // Split name safely
            const nameParts = rowData.name ? rowData.name.split(" ") : [];
            const firstName = nameParts[0] || "";
            const lastName = nameParts.slice(1).join(" ") || "";

            // Handle image (if exists)
            let photoUrl = null;
            let photoInfo = null;

            if (rowData.coverUrl) {
                photoUrl = rowData.coverUrl; // already base64 or URL

                photoInfo = {
                    id: null,
                    contentType: "text/vcard",
                    filename: "vcard-image",
                    fileData: rowData.coverUrl.includes("base64")
                        ? rowData.coverUrl.split(",")[1]
                        : rowData.coverUrl,
                };
            }
            const companyCountry =
                this.countryListArray.find(
                    (c) =>
                        c.namecode?.toLowerCase() ===
                        rowData?.workAddress?.[0]?.country?.toLowerCase()
                ) || this.defaultCountry;

            this.setState({
                open: true,
                action: "edit",
                firstName: firstName,
                lastName: lastName,
                companyName: rowData.org || "",
                companyEmail: rowData.emails?.[1] || "",
                email: rowData.emails?.[0] || "",
                website: rowData.urls?.[0] || "",
                orgPhoneNumber: rowData.orgMobilePhone || "",
                phoneNumber: rowData.phoneNumber || "",
                note: rowData.note || "",
                companyLine: rowData.workAddress?.street || "",
                companyCity: rowData.workAddress?.city || "",
                companyZipCode: rowData.workAddress?.postalCode || "",
                companyCountry: { namecode: rowData.workAddress?.country || "" },
                companyState: { namecode: rowData.workAddress?.state || "" },
                isCompanyAddress: rowData?.workAddress?.street !== "" ? true : false,
                line: rowData.homeAddress?.street || "",
                city: rowData.homeAddress?.city || "",
                zipCode: rowData.homeAddress?.postalCode || "",
                country: { namecode: rowData.homeAddress?.country || "" },
                state: { namecode: rowData.homeAddress?.state || "" },
                isPersonalDetails: firstName !== "" ? true : false,
                isPersonalAddress: rowData?.homeAddress?.street !== "" ? true : false,
                photoUrl: photoUrl,
                photoInfo: photoInfo,
            });
        } else {
            this.setState({
                open: true,
                action: "create",
                firstName: "",
                lastName: "",
                companyName: "",
                companyEmail: "",
                email: "",
                website: "",
                orgPhoneNumber: "",
                phoneNumber: "",
                note: "",
                photoUrl: null,
                photoInfo: null,
                companyCountry: null,
                companyState: null,
            });
        }
    }

    handleClose() {
        this.setState({
            open: false,
        })
    }

    handleFirstNameChange(e) {
        this.setState({
            firstName: e.target.value
        })
    }
    handleLastNameChange(e) {
        this.setState({
            lastName: e.target.value
        })
    }
    handleCompanyNameChange(e) {
        this.setState({
            companyName: e.target.value
        })
    }

    handlePhoneNumberChange = (e) => {
        let value = e.target.value;

        // Allow only numbers and +
        value = value.replace(/[^0-9+]/g, "");

        // Allow only one + and only at the start
        if (value.includes("+")) {
            value = "+" + value.replace(/\+/g, "").replace(/^\+/, "");
        }
        this.setState({
            phoneNumber: value,
        });
    };
    handleOrgPhoneNumberChange = (e) => {
        let value = e.target.value;

        // Allow only numbers and +
        value = value.replace(/[^0-9+]/g, "");

        // Allow only one + and only at the start
        if (value.includes("+")) {
            value = "+" + value.replace(/\+/g, "").replace(/^\+/, "");
        }
        this.setState({
            orgPhoneNumber: value,
        });
    };

    handleEmailChange(e) {
        this.setState({
            email: e.target.value
        })
    }


    handleWebsiteChange(e) {
        this.setState({
            website: e.target.value
        })
    }

    handleLineChange(e) {
        let val = e.target.value;
        let res = val.substring(0, 128);
        if (res.length < 128) {
            this.setState({ line: res });
        } else {
            Utils.maxFieldLength(128);
        }
    }

    handleCityChange(e) {
        let val = Utils.toCamelCase(e.target.value);
        let res = val.substring(0, 128);
        if (res.length < 128) {
            this.setState({ city: res });
        } else {
            Utils.maxFieldLength(128);
        }
    }

    handlePinCodeChange(e) {
        let val = e.target.value;
        let res = val.substring(0, 5);
        if (res.length < 6) {
            this.setState({ zipCode: res, zipCodeErrorMessageText: "" });
        } else {
            this.setState({
                zipCodeErrorMessageText:
                    "The size of this field is limited to 5 characters only",
            });
        }
    }

    handleStateChange(selectedState) {
        this.setState({ state: selectedState });
    }

    handleCountryChange(selectedCountry) {
        if (null === selectedCountry || selectedCountry === "") {
            this.stateListArray = [];
            this.setState({
                stateClear: !this.state.stateClear,
            });
            return;
        }
        this.setState({
            country: selectedCountry,
            state: null,
        });

        const postObject = {
            header: {},
            country: { id: selectedCountry?.id },
        };
        FetchServerData.callPostService("/countryms/get", postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {
                    let stateTimezoneList = output.data.country;
                    this.stateListArray = stateTimezoneList.states;
                    this.setState({
                        render: true,
                    });
                } else {
                }
            }
        );
    }

    handleCompanyEmailChange(e) {
        this.setState({
            companyEmail: e.target.value
        })
    }

    handleCompanyLineChange(e) {
        let val = e.target.value;
        let res = val.substring(0, 128);
        if (res.length < 128) {
            this.setState({ companyLine: res });
        } else {
            Utils.maxFieldLength(128);
        }
    }

    handleCompanyCityChange(e) {
        let val = Utils.toCamelCase(e.target.value);
        let res = val.substring(0, 128);
        if (res.length < 128) {
            this.setState({ companyCity: res });
        } else {
            Utils.maxFieldLength(128);
        }
    }

    handleCompanyPinCodeChange(e) {
        let val = e.target.value;
        let res = val.substring(0, 5);
        if (res.length < 6) {
            this.setState({ companyZipCode: res, companyZipCodeErrorMessageText: "" });
        } else {
            this.setState({
                companyZipCodeErrorMessageText:
                    "The size of this field is limited to 5 characters only",
            });
        }
    }

    handleCompanyStateChange(selectedState) {
        this.setState({ companyState: selectedState });
    }

    handleCompanyCountryChange(selectedCountry) {
        if (null === selectedCountry || selectedCountry === "") {
            this.companyStateListArray = [];
            this.setState({
                stateClear: !this.state.stateClear,
            });
            return;
        }
        this.setState({
            companyCountry: selectedCountry,
            companyState: null,
        });

        const postObject = {
            header: {},
            country: { id: selectedCountry?.id },
        };
        FetchServerData.callPostService("/countryms/get", postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {
                    let stateTimezoneList = output.data.country;
                    this.companyStateListArray = stateTimezoneList.states;
                    this.setState({
                        render: true,
                    });
                } else {
                }
            }
        );
    }

    handleNoteChange(e) {
        this.setState({
            note: e.target.value
        })
    }

    handleIsPersonalAddressChange = (e) => {
        const checked = e.target.checked;

        if (checked) {
            this.setState(
                {
                    isPersonalAddress: true,
                    country: this.defaultCountry,
                },
                () => {
                    this.handleCountryChange(this.defaultCountry);
                }
            );
        } else {
            this.setState({
                isPersonalAddress: false,
                country: null,
                state: null,
                line: "",
                city: "",
                zipCode: "",
            });
        }
    };

    handleIsPersonalDetailsChange = (e) => {
        this.setState({
            isPersonalDetails: e.target.checked
        })
    };

    handleIsCompanyAddressChange = (e) => {
        const checked = e.target.checked;

        if (checked) {
            this.setState(
                {
                    isCompanyAddress: true,
                    companyCountry: this.defaultCountry,
                },
                () => {
                    this.handleCompanyCountryChange(this.defaultCountry);
                }
            );
        } else {
            this.setState({
                isCompanyAddress: false,
                companyCountry: null,
                companyState: null,
                companyLine: "",
                companyCity: "",
                companyZipCode: "",
            });
        }
    };

    createVcardToBackend() {
        const postObject = {
            header: this.header,
            vcard: {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                companyName: this.state.companyName,
                tollfreeNumber: this.tollfreeNumber,
                workPhone: this.state.orgPhoneNumber,
                mobilePhone: this.state.phoneNumber,
                personalEmail: this.state.email,
                workEmail: this.state.companyEmail,
                companyWebsite: this.state.website,
                homeAddress: {
                    street: this.state.line,
                    city: this.state.city,
                    country: this.state.country ? this.state.country?.namecode : "",
                    state: this.state.state ? this.state.state?.namecode : "",
                    zipCode: this.state.zipCode,
                },
                workAddress: {
                    street: this.state.companyLine,
                    city: this.state.companyCity,
                    country: this.state.companyCountry ? this.state.companyCountry?.namecode : "",
                    state: this.state.companyState ? this.state.companyState?.namecode : "",
                    zipCode: this.state.companyZipCode,
                },
                note: this.state.note,
                image: this.state.photoInfo,
            }
        }
        FetchServerData.callPostService("/vcardms/create", postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {
                    let vCardDetails = output.data;
                    this.props.onChange(vCardDetails);

                    this.setState({
                        open: false,
                        firstName: "",
                        lastName: "",
                        companyName: "",
                        email: "",
                        companyEmail: "",
                        phoneNumber: "",
                        orgPhoneNumber: "",
                        website: "",
                        line: "",
                        companyLine: "",
                        country: null,
                        companyCountry: null,
                        state: null,
                        companyState: null,
                        city: "",
                        companyCity: "",
                        zipCode: "",
                        companyZipCode: "",
                        photoInfo: null,
                        photoUrl: null,
                        isDragging: false,
                        isCompanyAddress: false,
                        isPersonalAddress: false,
                    })
                } else {
                }
            }
        );
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({ selectedFile: file });
            this.optinFileHandler(file);
        }
    };

    handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            this.setState({ selectedFile: file, isDragging: false });
            this.optinFileHandler(file);
        }
    };

    handleDragOver = (e) => {
        e.preventDefault();
        this.setState({ isDragging: true });
    };

    handleDragLeave = (e) => {
        e.preventDefault();
        this.setState({ isDragging: false });
    };

    optinFileHandler = async (file) => {
        if (!file) return;

        const fileName = file?.name?.toLowerCase();
        const fileExtension = fileName.split(".").pop();
        const allowedExtensions = ["png", "jpg", "jpeg", "gif", "heic", "heif"];

        if (!allowedExtensions.includes(fileExtension)) {
            PtsAlert.error(
                "Invalid file type. Please upload JPEG, PNG, GIF, HEIC, or HEIF images only."
            );
            return;
        }

        let workingFile = file;
        let documentType = file.type?.split("/")[0] || "image";

        // If HEIC/HEIF → convert to JPEG
        if (fileExtension === "heic") {
            const converted = await heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.9,
            });

            const convertedBlob =
                converted instanceof Blob ? converted : converted[0];

            workingFile = new File(
                [convertedBlob],
                file.name.replace(/\.\w+$/, ".jpg"),
                { type: "image/jpeg" }
            );
            documentType = "image";

        }

        const fileUrl = URL.createObjectURL(workingFile);
        const reader = new FileReader();

        reader.onloadend = () => {
            let base64Data = reader.result;

            if (typeof base64Data === "string" && base64Data.startsWith("data:")) {
                base64Data = base64Data.split(",")[1];
            }

            const img = new Image();

            img.onload = () => {
                const sizeKB = Math.round(workingFile.size / 1024);

                if (img.width > 480 || img.height > 480) {
                    PtsAlert.error("Image dimensions must be 480×480 pixels or smaller.");
                    return;
                }


                if (sizeKB > 225) {
                    PtsAlert.error("Image size should be around 224 KB.");
                    return;
                }
                this.setState({
                    selectedFile: workingFile,
                    documentType,
                    photoUrl: fileUrl,
                    photoInfo: {
                        id: null,
                        contentType: "text/vcard",
                        filename: workingFile.name,
                        fileData: base64Data,
                    },
                });
            };

            img.onerror = () => {
                PtsAlert.error("Unable to read image file.");
            };

            img.src = reader.result;
        };

        reader.onerror = () => {
            PtsAlert.error("Failed to read file. Please try again.");
        };

        reader.readAsDataURL(workingFile);
    };

    deleteImageInBackend() {
        this.setState({
            photoUrl: null,
            selectedFile: { name: "" },
        });
    }

    render() {
        return (
            <Dialog
                open={this.state.open}
                onClose={this.handleClose.bind(this)}
                maxWidth="xl"
                className="vcardFormDialogue"
            >
                <DialogTitle id="scroll-dialog-title">
                    <span style={{ color: "#fff" }}>
                        {this.state.action === "edit" ? "Edit vCard" : "Create vCard"}
                    </span>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={this.handleClose.bind(this)}
                    style={{
                        position: "absolute",
                        right: 8,
                        top: 4,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
                </IconButton>
                <DialogContent>
                    <div
                        style={{
                            width: "100%",
                            color: "#000",
                            fontSize: "small",
                            padding: "1.5em  1em",
                        }}
                    >
                        <ValidatorForm className="text-start"
                            ref="form"
                            onSubmit={this.createVcardToBackend.bind(this)}>

                            <div className="row">
                                <h6 className="mb-0" id="headerLabel">
                                    Company Details
                                </h6>
                            </div>
                            <div className="row mt-2">
                                <label
                                    className="col-sm-4 col-form-label"
                                    htmlFor="collapsible-lastname"
                                >
                                    Company Name*
                                </label>
                                <div className="col-sm-8" id="assetFormLabel">
                                    <input
                                        title=""
                                        required
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.companyName}
                                        onChange={this.handleCompanyNameChange.bind(
                                            this
                                        )}

                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <label
                                    className="col-sm-4 col-form-label"
                                    htmlFor="collapsible-lastname"
                                >
                                    Website
                                </label>
                                <div className="col-sm-8" id="assetFormLabel">
                                    <input
                                        title=""
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.website}
                                        onChange={this.handleWebsiteChange.bind(
                                            this
                                        )}

                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <label
                                    className="col-sm-4 col-form-label"
                                    htmlFor="collapsible-lastname"
                                >
                                    Email
                                </label>
                                <div className="col-sm-8" id="assetFormLabel">
                                    <input
                                        title=""
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.companyEmail}
                                        onChange={this.handleCompanyEmailChange.bind(
                                            this
                                        )}

                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <label
                                    className="col-sm-4 col-form-label"
                                    htmlFor="collapsible-lastname"
                                >
                                    Phone
                                </label>
                                <div className="col-sm-8" id="assetFormLabel">
                                    <input
                                        title=""
                                        type="text"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        value={this.state.orgPhoneNumber}
                                        onChange={this.handleOrgPhoneNumberChange.bind(
                                            this
                                        )}
                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                    />
                                </div>
                            </div>
                            {
                                this.tollfreeNumber !== null &&
                                this.tollfreeNumber !== undefined &&
                                < div className="row mt-2">
                                    <label
                                        className="col-sm-4 col-form-label align-self-center"
                                        htmlFor="collapsible-lastname"
                                    >
                                        Texting Number
                                    </label>
                                    <div className="col-sm-8 align-self-center textingNumber" id="assetFormLabel">
                                        {Utils.viewTollFreeNumberFormate(this.tollfreeNumber).slice(-12)}
                                    </div>
                                </div>
                            }
                            <div className="row mt-3 align-items-center">
                                <div className="d-flex align-items-center">
                                    <label
                                        htmlFor="companyAddress"
                                        className="col-sm-4 d-flex align-items-center mb-0"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h6 className="mb-0 me-2 fw-light" id="headerLabel">
                                            Address
                                        </h6>

                                        <input
                                            id="companyAddress"
                                            type="checkbox"
                                            value={this.state.isCompanyAddress}
                                            onChange={this.handleIsCompanyAddressChange.bind(
                                                this
                                            )}
                                            checked={this.state.isCompanyAddress}
                                            style={{ cursor: "pointer", marginTop: "2px" }}
                                        />
                                    </label>
                                </div>
                            </div>
                            {this.state.isCompanyAddress &&
                                <>
                                    <div className="row mt-3">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Street Address
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                onChange={this.handleCompanyLineChange.bind(this)}
                                                value={this.state.companyLine}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            City
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                title=""
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.companyCity}
                                                onChange={this.handleCompanyCityChange.bind(this)}

                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Country
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <Autocomplete
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                autoComplete="off"
                                                ListboxProps={{
                                                    className: "custom-listbox",
                                                }}
                                                options={this.countryListArray}
                                                value={
                                                    this.state.companyCountry ? this.state.companyCountry : this.defaultCountry
                                                }
                                                defaultValue={this.state.select}
                                                getOptionLabel={(option) => option.namecode}
                                                onChange={(event, value) => {
                                                    this.handleCompanyCountryChange(value);
                                                }}
                                                inputprops={{ style: { textTransform: "capitalize" } }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Please Select"
                                                        variant="outlined"
                                                        title=""
                                                        style={{ background: "#fff" }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            State
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <Autocomplete
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                ListboxProps={{
                                                    className: "custom-listbox",
                                                }}
                                                options={this.companyStateListArray}
                                                value={this.state.companyState}
                                                getOptionLabel={(option) => option.namecode}
                                                defaultValue={this.state.companyState}
                                                onChange={(event, value) => {
                                                    this.handleCompanyStateChange(value);
                                                }}
                                                inputprops={{ style: { textTransform: "capitalize" } }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Please Select"
                                                        variant="outlined"
                                                        size="small"
                                                        className="textField"
                                                        title=""
                                                        style={{ background: "#fff" }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Zip/Postal Code
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsLastName"
                                                className="form-control"
                                                value={this.state.companyZipCode}
                                                onChange={this.handleCompanyPinCodeChange.bind(this)}
                                                inputprops={{ maxLength: 16 }}

                                                name="zipCode"
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                            <hr></hr>
                            <div className="row">
                                <label
                                    htmlFor="personalDetails"
                                    className="d-flex align-items-center mb-0"
                                    style={{ cursor: "pointer" }}
                                >
                                    <h6 className="mb-0 me-2" id="headerLabel">
                                        Personal Details
                                    </h6>

                                    <input
                                        id="personalDetails"
                                        type="checkbox"
                                        value={this.state.isPersonalDetails}
                                        onChange={this.handleIsPersonalDetailsChange.bind(
                                            this
                                        )}
                                        checked={this.state.isPersonalDetails}
                                        style={{ cursor: "pointer", marginTop: "2px" }}
                                    />
                                </label>
                            </div>
                            {this.state.isPersonalDetails &&
                                <>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            First Name
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                title=""
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.firstName}
                                                onChange={this.handleFirstNameChange.bind(
                                                    this
                                                )}

                                                validators={["required"]}
                                                errormessages={["This field is required"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Last Name
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                title=""
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.lastName}
                                                onChange={this.handleLastNameChange.bind(
                                                    this
                                                )}

                                                validators={["required"]}
                                                errormessages={["This field is required"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Email
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                title=""
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.email}
                                                onChange={this.handleEmailChange.bind(
                                                    this
                                                )}

                                                validators={["required"]}
                                                errormessages={["This field is required"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <label
                                            className="col-sm-4 col-form-label"
                                            htmlFor="collapsible-lastname"
                                        >
                                            Phone
                                        </label>
                                        <div className="col-sm-8" id="assetFormLabel">
                                            <input
                                                title=""
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.phoneNumber}
                                                onChange={this.handlePhoneNumberChange.bind(
                                                    this
                                                )}
                                                validators={["required"]}
                                                errormessages={["This field is required"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-center mt-2">
                                        <div className="d-flex align-items-center">
                                            <label
                                                htmlFor="personalAddress"
                                                className="d-flex align-items-center mb-0"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h6 className="mb-0 me-2" id="headerLabel">
                                                    Address
                                                </h6>

                                                <input
                                                    id="personalAddress"
                                                    type="checkbox"
                                                    value={this.state.isPersonalAddress}
                                                    onChange={this.handleIsPersonalAddressChange.bind(
                                                        this
                                                    )}
                                                    checked={this.state.isPersonalAddress}
                                                    style={{ cursor: "pointer", marginTop: "2px" }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    {this.state.isPersonalAddress &&
                                        <>
                                            <div className="row mt-2">
                                                <label
                                                    className="col-sm-4 col-form-label"
                                                    htmlFor="collapsible-lastname"
                                                >
                                                    Street Address
                                                </label>
                                                <div className="col-sm-8" id="assetFormLabel">
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        id="multiStepsFirstName"
                                                        name="multiStepsFirstName"
                                                        className="form-control"
                                                        onChange={this.handleLineChange.bind(this)}
                                                        value={this.state.line}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <label
                                                    className="col-sm-4 col-form-label"
                                                    htmlFor="collapsible-lastname"
                                                >
                                                    City
                                                </label>
                                                <div className="col-sm-8" id="assetFormLabel">
                                                    <input
                                                        title=""
                                                        type="text"
                                                        autoComplete="off"
                                                        id="multiStepsFirstName"
                                                        name="multiStepsFirstName"
                                                        className="form-control"
                                                        value={this.state.city}
                                                        onChange={this.handleCityChange.bind(this)}

                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <label
                                                    className="col-sm-4 col-form-label"
                                                    htmlFor="collapsible-lastname"
                                                >
                                                    Country
                                                </label>
                                                <div className="col-sm-8" id="assetFormLabel">
                                                    <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        autoComplete="off"
                                                        ListboxProps={{
                                                            className: "custom-listbox",
                                                        }}
                                                        options={this.countryListArray}
                                                        value={
                                                            this.state.country ? this.state.country : this.defaultCountry
                                                        }
                                                        defaultValue={this.state.select}
                                                        getOptionLabel={(option) => option.namecode}
                                                        onChange={(event, value) => {
                                                            this.handleCountryChange(value);
                                                        }}
                                                        inputprops={{ style: { textTransform: "capitalize" } }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Please Select"
                                                                variant="outlined"
                                                                title=""
                                                                style={{ background: "#fff" }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <label
                                                    className="col-sm-4 col-form-label"
                                                    htmlFor="collapsible-lastname"
                                                >
                                                    State
                                                </label>
                                                <div className="col-sm-8" id="assetFormLabel">
                                                    <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                            className: "custom-listbox",
                                                        }}
                                                        options={this.stateListArray}
                                                        value={this.state.state}
                                                        getOptionLabel={(option) => option.namecode}
                                                        defaultValue={this.state.state}
                                                        onChange={(event, value) => {
                                                            this.handleStateChange(value);
                                                        }}
                                                        inputprops={{ style: { textTransform: "capitalize" } }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Please Select"
                                                                variant="outlined"
                                                                size="small"
                                                                className="textField"
                                                                title=""
                                                                style={{ background: "#fff" }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <label
                                                    className="col-sm-4 col-form-label"
                                                    htmlFor="collapsible-lastname"
                                                >
                                                    Zip/Postal Code
                                                </label>
                                                <div className="col-sm-8" id="assetFormLabel">
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        id="multiStepsLastName"
                                                        className="form-control"
                                                        value={this.state.zipCode}
                                                        onChange={this.handlePinCodeChange.bind(this)}
                                                        inputprops={{ maxLength: 16 }}

                                                        name="zipCode"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>
                            }
                            <hr></hr>
                            <div className="row">
                                <h6 className="mb-0" id="headerLabel">
                                    Notes
                                </h6>
                            </div>
                            <div className="row mt-2">
                                <div className="col-sm-12" id="assetFormLabel">
                                    <textarea
                                        title=""
                                        ref={this.textareaRef}
                                        value={this.state.note}
                                        onChange={this.handleNoteChange.bind(
                                            this
                                        )}
                                        className="form-control"
                                        rows="2"
                                    />

                                </div>
                            </div>
                            <hr></hr>
                            <div className="row">
                                <h6 className="mb-0" id="headerLabel">
                                    vCard Photo/Logo
                                </h6>
                            </div>
                            <div className="row mt-2">
                                <div className="col-sm-12" id="assetFormLabel">
                                    {this.state.photoUrl === null && (
                                        <div className="file-upload-wrapper">
                                            <label
                                                htmlFor="file-upload"
                                                className={`customImageVideo-file-upload ${this.state.isDragging
                                                    ? "dragging"
                                                    : ""
                                                    }`}
                                                onDrop={this.handleDrop}
                                                onDragOver={this.handleDragOver}
                                                onDragLeave={this.handleDragLeave}
                                            >
                                                <CloudUploadIcon className="upload-icon" />
                                                <span className="upload-text">
                                                    Drop file here or{" "}
                                                    <span className="browse-link">Browse for file</span>
                                                </span>

                                                <input
                                                    id="file-upload"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={this.handleFileChange}
                                                />
                                            </label>

                                            <small className="upload-note">
                                                (max 480x480 pix - PNG, JPEG, JPG, GIF, HEIC, HEIF) (224KB)
                                            </small>
                                        </div>
                                    )}
                                    {this.state.photoUrl && (
                                        <div className="d-flex justify-content-center">
                                            <img
                                                style={{
                                                    width: "auto",
                                                    height: "8em",
                                                    objectFit: "contain",
                                                    objectPosition: "left",
                                                }}
                                                alt=""
                                                src={
                                                    this.state.photoUrl
                                                        ? this.state.photoUrl
                                                        : ""
                                                }
                                            />
                                            <span className="fw-bold ms-2">
                                                <ClearIcon
                                                    className="logoDelete"
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius: "50%",
                                                        border: "solid 2px",
                                                        marginBottom: "10px",
                                                    }}
                                                    onClick={this.deleteImageInBackend.bind(
                                                        this
                                                    )}
                                                />
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-sm-12 text-center" id="assetFormLabel">
                                    <Button
                                        variant="contained"
                                        size="large"
                                        type="submit"
                                        style={{
                                            background: "#0B6F9D",
                                            color: "#fff",
                                            marginRight: "1rem",
                                            padding: "4px 10px",
                                            textTransform: "capitalize",
                                        }}
                                    >
                                        {this.state.action === "edit" ? "Save" : "Create"}
                                    </Button>
                                    &nbsp;&nbsp;
                                    <CancelIconButton
                                        onClick={(e) => this.handleClose()}
                                        pageId="Message"
                                    />
                                </div>
                            </div>
                        </ValidatorForm>
                    </div>
                </DialogContent >
            </Dialog >
        )
    }
}
export default MessageVcard;
